module.exports = __webpack_public_path__ + "src/assets/textures/env/hut/trough_02_512_bake.png";